import React, { Fragment } from 'react';
import DocumentTitle from 'react-document-title';

import CompanyPage from '../components/company/company-page';

const CompanyRoute = () => (
  <Fragment>
    <DocumentTitle title="Company | NerdWallet" />
    <CompanyPage />
  </Fragment>
);

CompanyRoute.displayName = 'CompanyRoute';
CompanyRoute.analyticsName = 'company_page';

export default CompanyRoute;
